<template>
  <pagefra>
    <div class="oms">
      <div>
        <section class="modular">
          <div class="top">
            <h1>
              <img src="../assets/bivale/img/bk.png" alt="BIVALE-解决方案" />
            </h1>
            <p class="arrows">
              <img src="../assets/bivale/img/icon.png" />
            </p>
          </div>
          <div class="content-list">
            <div>
              <h3>
                <img
                  src="../assets/bivale/img/3fd97340d974eb0b6218331544fb7f98.png"
                />
              </h3>
              <ul>
                <li>楼宇门禁管理解决方案</li>
                <li>高安全性安防管理解决方案</li>
                <li>移动认证解决方案</li>
                <li>对讲电梯联动解决方案</li>
                <li>视频监控解决方案</li>
                <li>温度筛查管理解决方案</li>
                <li>出入口人车统一管理解决方案</li>
              </ul>
            </div>
            <div>
              <h3>
                <img
                  src="../assets/bivale/img/bac9efe49160497684fc1341256f5c50.png"
                />
              </h3>
              <ul>
                <li>记账消费管理解决方案</li>
                <li>机电设备管理解决方案</li>
                <li>楼宇设备综合管理解决方案</li>
                <li>智能梯控解决方案</li>
              </ul>
            </div>
            <div>
              <h3>
                <img
                  src="../assets/bivale/img/4532f5eaf10c731569675d5fef41e59b.png"
                />
              </h3>
              <ul>
                <li>能源可视化管理解决方案</li>
                <li>智能照明管理解决方案</li>
                <li>空调管理解决方案</li>
                <li>环境监测可视化解决方案</li>
                <li>电能管理解决方案</li>
                <li>水能管理解决方案</li>
              </ul>
            </div>
          </div>
        </section>
        <section class="advantage">
          <div class="top">
            <h1>
              <img src="../assets/bivale/img/ys.png" alt="BIVALE-解决方案" />
            </h1>
            <p class="arrows">
              <img src="../assets/bivale/img/icon.png" />
            </p>
          </div>
          <div class="content-list">
            <div>
              <h3>通过无服务器的简单应用维持管理、减少成本</h3>
              <p>
                <span
                  >客户将设备所必要的功能和数据汇总到BIVALE服务器，并通过云端利用个人电脑控制应用和管理，因此在保证维护和管理的质量的同时又可减少成本。</span
                >
              </p>
            </div>
            <div>
              <h3>通过统一管理多个网点，促进管理工作效率化</h3>
              <p>
                <span
                  >BIVALE将日立在设备管理上丰富的知识技术融合到云端。在管理楼宇的能源使用量统计、空调和照明节能对策、企业安防制度统一化、楼宇设施的远程控制上可以有多种多样的管理和应用形态，即使要管理多个网点，也可以根据建筑物的状况和需求，选择导入必要的服务。因此通过统一客户复杂的管理工作，可促进工作效率化。</span
                >
              </p>
            </div>
            <div>
              <h3>通过提高租赁服务而提高楼宇资产价值</h3>
              <p>
                <span
                  >通过云端型服务BIVALE，管理员可以赋予租户必要的管理权限。租户可以自行进行节能活动和安防管理，以此简化租户和管理员的管理工作。此外，BIVALE可以迅速发现楼宇设备的故障状态，并对设备进行远程控制，因此能够迅速应对租户的需求，提高楼宇的资产价值。</span
                >
              </p>
            </div>
            <div>
              <h3>通过自由添加模块系统，满足多样化管理需求</h3>
              <p>
                <span
                  >BIVALE的模块并非相互独立，而是可以互相结合。客户可以自由地选装三大模块中的系统和功能，组合成不同的管理体系，实现不同的独特需求。</span
                >
              </p>
            </div>
            <div>
              <h3>全天候的支援服务</h3>
              <p>
                <span
                  >具备在故障发生时，提供7*24小时的支援服务。客服中心日常监视设备机器是否发生故障，若发生故障，可以及时联系管理员并提供必要的信息。此外，在假日和夜间遗失IC卡等识别设备时，收到管理员的通知后代办IC卡等识别设备停用业务。</span
                >
              </p>
            </div>
          </div>
        </section>
        <section class="pageFrame">
          <div class="top">
            <h2>视频</h2>
            <p class="arrows">
              <img src="../assets/bivale/img/icon.png" />
            </p>
          </div>
          <div class="video-list">
            <a href="javascript:;" @click="video1 = true">
              <h3>BIVALE 理念</h3>
              <p>
                <img
                  src="../assets/bivale/img/cd8bf2f8e6272e307d48b4474f67b805.jpg"
                />
              </p>
              <p class="i-case-more m-top10">查看详情>></p>
            </a>
            <a href="javascript:;" @click="video2 = true">
              <h3>BIVALE 应用</h3>
              <p>
                <img
                  src="../assets/bivale/img/8bfd62b0c842ff7ad2df196ac92e862a.jpg"
                />
              </p>
              <p class="i-case-more m-top10">查看详情>></p>
            </a>
          </div>
          <a href="http://www.bivale.com.cn" target="_blank">了解更多</a>
          <a href="doc/bivale折页（中文）.pdf" target="_blank">BIVALE折页</a>
        </section>
        <div
          class="modal"
          :class="{ show: video1, none: conceal1 }"
          @click.self="closeVideo(1)"
        >
          <div>
            <video ref="video1" width="100%" height="auto" controls>
              <source
                src="assets/bivale/img/da74b48dff2856d49b5a3d4587d1bd2a.mp4"
                type="video/mp4"
              />
              您的浏览器不支持Video标签。
            </video>
            <div class="video-info">
              <div>
                <h3>BIVALE 理念</h3>
                <p>视频介绍:</p>
                <p>BIVALE 宣传视频1</p>
              </div>
              <div>
                <a href="javascript:void(0);" @click="closeVideo(1)">关闭</a>
              </div>
            </div>
          </div>
        </div>
        <div class="modal" :class="{ show: video2, none: conceal2 }" @click.self="closeVideo(2)">
          <div>
            <video ref="video2" width="100%" height="auto" controls>
              <source
                src="assets/bivale/img/069fec034840ce1a83d2dd08252d5384.mp4"
                type="video/mp4"
              />
              您的浏览器不支持Video标签。
            </video>
            <div class="video-info">
              <div>
                <h3>BIVALE 应用</h3>
                <p>视频介绍:</p>
                <p>2020年中国国际电梯展上首播</p>
              </div>
              <div>
                <a href="javascript:void(0);" @click="closeVideo(2)">关闭</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </pagefra>
</template>

<script>
import panel from "../components/panel.vue";
import global from "../mixins/global.js";
export default {
  name: "oms",
  mixins: [global],
  components: {
    panel,
  },
  data() {
    return {
      video1: false,
      video2: false,
      conceal1: true,
      conceal2: true,
    };
  },
  watch: {
    video1() {
      if (!this.video1) {
        setTimeout(() => {
          this.conceal1 = true;
        }, 300);
      } else {
        this.conceal1 = false;
      }
    },
    video2() {
      if (!this.video2) {
        setTimeout(() => {
          this.conceal2 = true;
        }, 300);
      } else {
        this.conceal2 = false;
      }
    },
  },
  methods: {
    closeVideo(type){
      if(type == 1){
        this.video1 = false;
        this.$refs.video1.load();
      }else{
        this.video2 = false;
        this.$refs.video2.load();
      }
    }
  },
  mounted() {},
  created() {
    this.$store.state.isShowMenu = false;
  },
};
</script>
<style lang="scss" scoped>
.oms {
  width: 100%;
  height: 100%;
  background-color: #f0f1f2;
  & > div {
    max-width: 1200px;
    margin: 50px auto;
    &:after {
      clear: both;
      content: "";
      width: 0;
      height: 0;
      display: block;
      visibility: hidden;
    }
  }
}
.modular {
  .content-list {
    margin-top: 100px;
    display: flex;
    justify-content: space-between;
    padding-bottom: 120px;
    border-bottom: 1px solid #c9c9c9;
    & > div:nth-child(2) {
      margin: 0 20px;
    }
    li {
      font-size: 24px;
      text-indent: 30px;
      background: url(../assets/bivale/img/icon02.png) left center no-repeat;
      height: 50px;
      line-height: 50px;
    }
  }
}
.advantage {
  margin-top: 50px;
  .content-list {
    & > div {
      margin-top: 70px;
      padding-left: 200px;
      min-height: 154px;
      h3 {
        font-size: 34px;
        margin-bottom: 10px;
        font-weight: 400;
      }
      p {
        font-size: 18px;
        line-height: 36px;
      }
    }
    & > div:nth-child(1) {
      background: url(../assets/bivale/img/icon-1.png) left top no-repeat;
    }
    & > div:nth-child(2) {
      background: url(../assets/bivale/img/icon-2.png) left top no-repeat;
    }
    & > div:nth-child(3) {
      background: url(../assets/bivale/img/icon-3.png) left top no-repeat;
    }
    & > div:nth-child(4) {
      background: url(../assets/bivale/img/icon-4.png) left top no-repeat;
    }
    & > div:nth-child(5) {
      background: url(../assets/bivale/img/icon-5.png) left top no-repeat;
    }
  }
}
.pageFrame {
  padding-top: 100px;
  h2 {
    font-size: 50px;
  }
  .video-list {
    display: flex;
    padding: 100px 0;
    justify-content: space-between;
    a {
      transition: all 0.2s ease-out 0s;
      -webkit-transition: all 0.2s ease-out 0s;
      -moz-transition: all 0.2s ease-out 0s;
      text-decoration: none;
      width: 568px;
      height: 450px;
      box-shadow: 0px 0px 8px #999;
      padding: 22px;
      display: inline-block;
      color: #383e47;
      &:hover {
        box-shadow: 0px 0px 8px #ca0005;
        p:last-child {
          border-color: #ca0005;
        }
      }
      &:first-child {
        margin-right: 35px;
      }
    }
    img {
      width: 100%;
      height: 100%;
    }
    h3 {
      font-size: 34px;
      float: left;
      font-weight: 400;
      margin-bottom: 10px;
    }
    p:last-child {
      padding: 6px 15px;
      border: 1px solid #333;
      display: inline-block;
      margin: 10px 0;
    }
  }
  & > a {
    transition: all 0.2s ease-out 0s;
    -webkit-transition: all 0.2s ease-out 0s;
    -moz-transition: all 0.2s ease-out 0s;
    padding: 8px 20px;
    background: #b90005;
    color: #fff;
    font-size: 16px;
    text-decoration: none;
    float: right;
    margin-left: 10px;
    &:hover {
      background: #d8d8d8;
      color: #b90005;
    }
  }
}
.top {
  .arrows {
    margin: 30px 0 10px 0;
  }
}
.show {
  opacity: 1 !important;
  z-index: 1050 !important;
}
.none {
  z-index: -1050;
}
.modal {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow-x: hidden;
  overflow-y: auto;
  transition: opacity 0.3s linear;
  background-color: rgba(0, 0, 0, 0.4);
  opacity: 0;
  & > div {
    width: 1200px;
    margin: 0 auto;
    margin-top: 120px;
  }
  .video-info {
    color: #fff;
    display: flex;
    flex-wrap: wrap;
    margin-top: 30px;
    & > div:first-child {
      flex: 1;
    }
    & > div:last-child {
      display: flex;
      align-items: center;
    }
    h3 {
      font-size: 30px;
      font-weight: 400;
      margin-bottom: 10px;
    }
    p {
      font-size: 16px;
      margin-bottom: 10px;
    }
    a {
      height: auto;
      padding: 8px 20px;
      background: #b90005;
      color: #fff;
      transition: all 0.2s ease-out 0s;
      -webkit-transition: all 0.2s ease-out 0s;
      -moz-transition: all 0.2s ease-out 0s;
      text-decoration: none;
      &:hover {
        background: #d8d8d8;
        color: #b90005;
      }
    }
  }
}
</style>
